import i18n from '@/i18n';
import {EventType} from '@/services/graphqlHooks';

const eventTypes = {
  [EventType.Casual]: i18n.t('Casual'),
  [EventType.Medical]: i18n.t('Medical'),
  [EventType.Rehabilitation]: i18n.t('Rehabilitation'),
  [EventType.Unverified]: i18n.t('Unverified'),
} as Record<EventType, string>;

export default eventTypes;
